/**
 * zIndex
 * use zIndex wisely, try not to add z index unnecessarily
 */
var zIndexList;
(function (zIndexList) {
    zIndexList[zIndexList["ToastContainer"] = 2147483647] = "ToastContainer";
    zIndexList[zIndexList["bottomSheet"] = 99999999] = "bottomSheet";
    zIndexList[zIndexList["modal"] = 1100] = "modal";
})(zIndexList || (zIndexList = {}));
/**
 * SCSS variables
 */
/**
 * file - dashboard.module.scss
 * .topSection - zIndex: 100
 * Used in advance filter bottom sheet - listing page
 * reason sticky filter header has zindex 1 but bottom and top nav has 100 so need to match it
 */
var zIndexList$1 = zIndexList;

export { zIndexList$1 as default };
//# sourceMappingURL=zIndexList.js.map
